module.exports = __webpack_public_path__ + "static/media/Mask Group 21.e29e2797.svg";